import styled, { useTheme } from 'styled-components';
import { AuthorPageLink } from './contracts';

export const transitionStyles = {
	entering: { opacity: 0 },
	entered: { opacity: 1 },
	exiting: { opacity: 1 },
	exited: { opacity: 0 }
};

export const CompactItemsWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(300px, max-content));
	padding: 2rem;
	padding-top: 2rem;
	grid-gap: 4rem;
	justify-content: center;
	align-items: flex-start;
`;

export const Compact = styled.div<{ $hasImage: boolean; $showFullReadMore?: boolean; $numberOfReadMoreLines?: number }>`
	flex-direction: column;
	display: flex;
	gap: 0.5rem;
	width: 300px;
	border-radius: 10px;
	border: 1px solid ${props => props.theme.palette.grey[300]};
	transition: transform 0.2s ease-in-out;
	.event-title {
		-webkit-line-clamp: 3;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
	.read-more {
		${props =>
			props.$showFullReadMore && !props.$numberOfReadMoreLines ? '' : `-webkit-line-clamp: ${props.$numberOfReadMoreLines ?? 2};`}
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
	${props => (props.$hasImage ? 'padding-top: 0rem;' : '')}
	@media (min-width: 800px) {
		&:hover {
			transform: scale(1.02);
		}
	}
`;

export const InnerCompact = styled.div`
	flex-direction: column;
	display: flex;
	padding-bottom: 2rem;
	padding: 1rem;
	gap: 0.5rem;
`;

export const ResponsiveItemWrapper = styled.div`
	@media (max-width: 600px) {
		${Compact} {
			width: 100%;
		}
		img {
			width: 100% !important;
		}
		${CompactItemsWrapper} {
			display: flex;
			width: 100%;
			flex-direction: column;
			padding: 1rem;
			gap: 1rem;
		}
		a {
			width: 100% !important;
		}
	}
`;

export function renderAuthors(authorString: string, authorPageUrls?: AuthorPageLink[], readMoreTextColour?: string) {
	const theme = useTheme();
	// Replace semicolons with commas
	const authorsWithCommas = authorString.replace(/;/g, ',');

	// If no authorPageUrls, return the simple comma-separated string
	if (!authorPageUrls || authorPageUrls.length === 0) {
		return authorsWithCommas;
	}

	// Split authors by semicolons to match against authorPageUrls
	const authors = authorString.split(';').map(author => author.trim());

	return (
		<>
			{authors.map((author, index) => {
				// Find matching URL for this author
				const authorLink = authorPageUrls.find(link => link.author.trim().toLowerCase() === author.trim().toLowerCase());

				return (
					<span key={index}>
						{authorLink ? (
							<a
								href={authorLink.pageUrl}
								target="_blank"
								style={{
									color: readMoreTextColour || theme.palette.primary.main,
									textDecoration: 'none',
									fontWeight: 'bold'
								}}
							>
								{author}
							</a>
						) : (
							author
						)}
						{index < authors.length - 1 ? ', ' : ''}
					</span>
				);
			})}
		</>
	);
}
